import ContentfulTag from "../contentful/ContentfulTag";
import ContentfulToApiTag from "../mappings/ContentfulToApiTag";
import { get } from "lodash";

class ApiTag {
  static default = {
    id: "",
    name: "",
    numStories: 0,
  };

  static id = (apiTag: ApiTag): string => get(apiTag, "id", ApiTag.default.id);

  static tagName = (apiTag: ApiTag): string =>
    get(apiTag, "name", ApiTag.default.name);

  static numStories = (apiTag: ApiTag): number =>
    get(apiTag, "numStories", ApiTag.default.numStories);

  static async fetchWithId(id) {
    const contentfulTag = await ContentfulTag.fetchWithId(id);
    return ContentfulToApiTag.map(contentfulTag);
  }
}

export default ApiTag;
